
<script setup>
import { EmptyHeading, ButtonCta } from '@components'

const props = defineProps({
    pageContent: {
        type: Object,
        required: true
    }
})
</script>

<style>

</style>

<template>
    <div class="flex flex-col gap-[60px] items-center justify-center">
        <EmptyHeading :title="props.pageContent.heading.title" :subtitle="props.pageContent.heading.subtitle" :imgLink="props.pageContent.heading.imgLink" />
        <div class="flex flex-col gap-5">
            <ButtonCta v-for="(item, index) in props.pageContent.buttonCta" :key="index" :title="item.title" :subtitle="item.subtitle" :icon="item.icon" :link="item.link" />
        </div>
    </div>
</template>